import React, { memo } from 'react';
import PlayingCardArt from '../../common/PlayingCardArt';
import { SUIT_GLYPH, cardKey, isRed, rankLabel } from '../solitaireModel';

/** Solitaire card {r: 1..13, s} → the shared art card (same deck as Durak). */
export function toArtCard(card) {
  if (!card) return null;
  return { rank: rankLabel(card.r), value: card.r, suit: card.s, red: isRed(card) };
}

/**
 * One face-up card: the shared Durak SVG art with the large one-line corner index (rank + suit stay readable when
 * the column is fanned). Interaction is driven by pointer events from SolitairePage (drag & drop / tap).
 */
function PlayingCard({
  card, hinted, legal, over, dragging, draggable, shake, style, onPointerDown, testId,
}) {
  const label = `${rankLabel(card.r)}${SUIT_GLYPH[card.s] || '?'}`;
  const cls = [
    'sol-card',
    isRed(card) ? 'is-red' : 'is-black',
    draggable ? 'is-draggable' : '',
    hinted ? 'is-hinted' : '',
    legal ? 'is-legal' : '',
    over ? 'is-over' : '',
    dragging ? 'is-dragging' : '',
    shake ? 'is-shake' : '',
  ].filter(Boolean).join(' ');
  return (
    <div
      className={cls}
      style={style}
      onPointerDown={onPointerDown}
      data-testid={testId || `card-${cardKey(card)}`}
      role="img"
      aria-label={label}
    >
      <PlayingCardArt card={toArtCard(card)} corner="large" className="sol-card__art" />
    </div>
  );
}

export default memo(PlayingCard);

/** Face-down card (nothing about it is known on the client) — the shared card back. */
export function CardBack({ style, testId = 'card-back' }) {
  return (
    <div className="sol-card sol-card--back" style={style} data-testid={testId} aria-hidden="true">
      <PlayingCardArt card={null} className="sol-card__art" />
    </div>
  );
}
